import React, { useContext, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { reaction, runInAction } from 'mobx';

import * as S from './SaveMotion.style';

import { RootStoreContext } from '../../../../App';

import Image from '../../../image/Image';

import useMotionQuery from '../../../../hooks/queries/useMotionQuery';

import { ACTIONS, TAPS } from '../../../../data/motion';
import Spinner from '../../../spinner/Spinner';

const Motion = ({ motion }) => {
	const { likuStore, motionStore } = useContext(RootStoreContext);
	const { data } = useMotionQuery(motion.uuid);

	return (
		<S.Motion>
			<div className='start'>
				<button
					onClick={() => {
						if (motion.type === 'SCENARIO') {
							const scenarioMotions = motion.motions.map((s) => s.motion);
							likuStore.playJson(scenarioMotions);
						} else {
							const tempData = { ...data };

							if (data?.speech && !data?.speech?.TTS) {
								tempData.speech.TTS = motion?.name;
							} else {
								likuStore.playJson(tempData);
							}
						}
					}}>
					<Image srcArray={S.play_list} custom={S.PlayImage} />
				</button>
				{motion.type === 'CUSTOM' ? (
					<button
						onClick={() => {
							const tempData = { ...data };

							motionStore.setModifyMotion(motion, tempData);
						}}>
						{'수정'}
					</button>
				) : (
					<></>
				)}
			</div>
			<div className='info'>
				<div className='main'>
					<span className='name'>{motion.name}</span>
					{motion.type === 'CUSTOM' && (
						<div className='motion'>
							<div className='action'>
								{ACTIONS[data?.action?.action_name]?.name ||
									ACTIONS[data?.action?.action_name]}
							</div>
							<div className='display'>
								{data?.display?.display_name === 'defaultArray'
									? '표정 자동'
									: data?.display?.display_name}
							</div>
						</div>
					)}
					{motion.type === 'SCENARIO' && (
						<div className='motion'>
							<div className='scenario'>표현 묶음</div>
						</div>
					)}
				</div>
				{motion.type === 'SCENARIO' && (
					<div className='sub'>
						{/*<span className='scenarioName'>{motion?.name}</span>*/}
						{motion.isDetail &&
							motion?.motions?.map((motion, index) => {
								return (
									<S.SubMotion key={`${motion?.info}-${index}`}>
										<span className='number'>{index + 1}</span>
										<div className='info'>{motion?.info}</div>
										<button>
											<Image srcArray={S.adjustable_list} />
										</button>
									</S.SubMotion>
								);
							})}
					</div>
				)}
			</div>
			<div className='btnContainer'>
				<button
					onClick={() => {
						if (motion?.motions?.length) {
							motion?.motions?.map((tempMotion) => {
								if (tempMotion?.speech && !tempMotion?.speech?.TTS) {
									tempMotion.speech.TTS = data?.name;
								}
								motionStore.setPlayList(tempMotion);
							});
						} else {
							if (motion?.speech && !motion?.speech?.TTS) {
								motion.speech.TTS = data?.name;
							}
							motionStore.setPlayList(motion);
						}
					}}>
					<Image srcArray={S.add_list_list} custom={S.AddListImage} />
				</button>
				{motion.type === 'CUSTOM' || motion.type === 'SCENARIO' ? (
					<button
						onClick={() => {
							if (motion.type === 'SCENARIO') {
								if (motion.id === 673) {
									alert('OT 시나리오는 삭제할 수 없습니다.');
									return;
								}
								motionStore.deleteScenario(motion.id);
							} else {
								motionStore.deleteMotion(motion.uuid);
							}
						}}>
						{'x'}
					</button>
				) : (
					<></>
				)}
			</div>
		</S.Motion>
	);
};

const SaveMotion = observer(({ isVisible }) => {
	const { motionStore } = useContext(RootStoreContext);
	const [isDetail, setIsDetail] = useState(false);
	const [choseTap, setChoseTap] = useState('BASIC');
	const [motionList, setMotionList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [render, setRender] = useState(false);

	const updateMotionList = (_choseTap = 'BASIC') => {
		const list = motionStore.getMotions(_choseTap);
		setMotionList(list);
	};

	useEffect(() => {
		const dispose = reaction(
			() => motionStore.motions,
			() => {
				updateMotionList(choseTap);
				setRender(!render);
			},
		);

		return () => dispose();
	}, [choseTap]);

	useEffect(() => {
		(async () => {
			if (!motionStore.motions?.length && isVisible) {
				setIsLoading(true);
				await motionStore.loadMotion();
				setIsLoading(false);
			}
			updateMotionList(choseTap);
		})();
	}, [choseTap, render, isVisible]);

	useEffect(() => {
		if (motionStore.isModified) {
			runInAction(() => {
				motionStore.isModified = false;
			});
			setMotionList([]);
			setRender(!render);
		}
	}, [motionStore.isModified]);

	const taps = TAPS.map(({ key, name }) => (
		<S.Tap key={key} click={key === choseTap} onClick={() => setChoseTap(key)}>
			{name}
		</S.Tap>
	));
	// 리쿠Ot 모션도 모든 사용자에게 노출돼서 필터링
	const motions = motionList
		?.filter((motion) => motion.id < 12252 || motion.id > 12288)
		.map((motion, index) => (
			<Motion
				chooseTap={choseTap}
				key={`${motion.uuid}_${index}`}
				motion={motion}
			/>
		));

	const scenarios = motionStore.scenarios
		?.filter((scenario) => scenario?.id)
		?.map((scenario, index) => {
			return (
				<Motion
					chooseTap={choseTap}
					key={`${scenario?.id}_${index}`}
					motion={{ ...scenario, type: 'SCENARIO', isDetail: isDetail }}
				/>
			);
		});

	return (
		<S.SaveMotionBox className='light' isDetail={isDetail}>
			<div className='title'>
				{/*<div className='tooltip'>*/}
				{/*	저장된 표현*/}
				{/*	<span className='tooltiptext tooltip-right'>툴팁</span>*/}
				{/*</div>*/}
				저장된 표현
				<button className='toggleZoom' onClick={() => setIsDetail(!isDetail)}>
					<Image srcArray={isDetail ? S.zoom_out_list : S.zoom_in_list} />
				</button>
			</div>
			<div className='content'>
				<S.TapBar>{taps}</S.TapBar>
				<S.MotionWrap>
					{isLoading ? <Spinner /> : ''}
					{choseTap === 'CUSTOM' && scenarios}
					{motions}
				</S.MotionWrap>
			</div>
		</S.SaveMotionBox>
	);
});

export default SaveMotion;
